import { useBoumClaimsConsumer } from '@backoffice-frontend/restricted'
import { useCallback, useRef } from 'react'
import { useSearchCustomersV2LazyQuery } from '../graphql/querySearchCustomersV2.hook'

// using nonsense term for search so query warms up search but result won't allocate memory
const WARMUP_SEARCH_TERM = 'thjlknjlvftiudyryut'
const WARMUP_MAX_RESULTS = 1

export const useCustomerSearchV2Warmup = () => {
  const boum = useBoumClaimsConsumer()
  const hasWarmedUp = useRef(false)

  const [executeWarmup] = useSearchCustomersV2LazyQuery({
    fetchPolicy: 'network-only',
    onError: () => {},
  })

  const triggerWarmup = useCallback(() => {
    if (hasWarmedUp.current) {
      return
    }

    const tenants = boum.customerTenants()
    const firstTenant = tenants[0]

    if (!firstTenant) {
      return
    }

    hasWarmedUp.current = true
    executeWarmup({
      variables: {
        searchTerm: WARMUP_SEARCH_TERM,
        tenant: firstTenant,
        maxResults: WARMUP_MAX_RESULTS,
      },
    })
  }, [boum, executeWarmup])

  return triggerWarmup
}
